import {
  getMinedexCommodityCategoryFilterDefaults,
  getMinedexSiteTypeDefaults,
  getMinedexTargetCategoryFilterDefaults,
} from '../../minedex/MinedexQueryTool';
import {
  sampleTypeDataPreSelected,
  defaultAssayMArkerColourSettings,
} from '../../soil-assay/AssayQueryTool';
import { defaultDrillHoleColourSettings } from '../../drill-hole/DrillHoleQueryTool';
import { getDefaultTenementTypeList } from '../../tenements/TenementOverlay';

export const DEFAULT_PRESET_ID = '__default__';
export const DEFAULT_PRESET_NAME = 'Default';
export const MAX_USER_PRESETS = 15;
export const PRESET_SCHEMA_VERSION = 1;

const cloneArray = (arr) => arr.map((item) => ({ ...item }));

export function getDefaultPreset() {
  return {
    overlayVisibility: {
      tenements: true,
      tenementLabels: true,
      amalgamationsPending: true,
      soils: true,
      dh: false,
      minedex: false,
      graticles: false,
      section19: true,
      waypoints: true,
    },
    layerVisibility: {
      hybrid: true,
      topo: false,
      street: false,
      geo100: false,
      geo200: false,
      bedrock: false,
      magnetic: false,
    },
    tenementFilters: {
      includePending: true,
      includeDead: false,
      includeLive: true,
      includeSurveyed: true,
      includeUnsurveyed: true,
      types: getDefaultTenementTypeList(),
      startDate: new Date(1800, 0, 1),
      endDate: new Date(3001, 0, 1),
      grantDate: new Date(1800, 0, 1),
      grantDateBeforeAfter: 'AFTER',
      deadSpls: false,
      grantedOnly: false,
      expiringSoonEnabled: false,
      ignoreFirstTermPl: true,
      overridePendingTenementDisplay: true,
      holderNameLike: '',
    },
    minedexFilters: {
      commodityCategory: getMinedexCommodityCategoryFilterDefaults(),
      targetCommodity: getMinedexTargetCategoryFilterDefaults(),
      siteType: getMinedexSiteTypeDefaults(),
      siteStageUnderDevelopment: true,
      siteStageCareAndMaint: true,
      siteStageOperating: true,
      siteStageShut: true,
      siteStageUndeveloped: true,
      siteStageProposed: true,
    },
    assayFilters: {
      ppblt: 9999,
      ppbmt: 30,
      maxresults: 500,
      type: sampleTypeDataPreSelected,
      nullValues: false,
      anumber: 0,
      bounds: {},
      // Load-date (gswa_load_date) period filter. Off by default so all
      // periods are shown; dateFrom/dateTo are 'YYYY-MM' month strings.
      dateFilterEnabled: false,
      dateFrom: '',
      dateTo: '',
    },
    drillHoleFilters: {
      gptlt: 9999,
      gptmt: 0.1,
      maxDepth: 20,
      anumber: 0,
    },
    assayMarkerColourSettings: cloneArray(defaultAssayMArkerColourSettings),
    drillHoleMarkerColourSettings: cloneArray(defaultDrillHoleColourSettings),
  };
}

export function getDefaultPresetEntry() {
  return {
    id: DEFAULT_PRESET_ID,
    name: DEFAULT_PRESET_NAME,
    version: PRESET_SCHEMA_VERSION,
    createdAt: null,
    updatedAt: null,
    payload: getDefaultPreset(),
    isBuiltIn: true,
  };
}
